export default "__VITE_ASSET__d5f0f5b5__"